import React, { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import axios from 'axios';
import Login from '../pages/Login';
import { TenantBrandingContext } from '../contexts/TenantBrandingContext';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Reserved slugs that are real app routes — never treat these as tenant portals
const RESERVED = ['login', 'dashboard', 'reset-password', 'projects', 'clients',
  'tenants', 'calendar', 'meetings', 'seo', 'invoices', 'billing', 'users',
  'profile', 'my-settings', 'forms', 'settings'];

const TenantPortal = () => {
  const { slug } = useParams();
  const [branding, setBranding] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!slug || RESERVED.includes(slug.toLowerCase())) {
      setNotFound(true);
      setLoading(false);
      return;
    }

    axios.get(`${API_URL}/tenant/branding?slug=${encodeURIComponent(slug.toLowerCase())}`)
      .then(res => {
        if (res.data?.id) {
          setBranding({ ...res.data, slug: slug.toLowerCase() });
        } else {
          setNotFound(true);
        }
      })
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="spinner" />
      </div>
    );
  }

  if (notFound) {
    return <Navigate to="/login" replace />;
  }

  // Inject branding into context so Login page picks it up
  return (
    <TenantBrandingContext.Provider value={{ branding, brandingLoading: false }}>
      <Login />
    </TenantBrandingContext.Provider>
  );
};

export default TenantPortal;
